define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/reflection",
	"csi/types",
	"csi/xml"
], function(declare,EnumRen,reflection,types,xml) {

	return declare(EnumRen, {
		 /**
		 * @override
		 * Render value for cell
		 */
		toValue: function(ctx, h) {
			const attrNode = ctx.getNode();
			if (!attrNode) {
				return "";
			}
			const isImage = attrNode[reflection.ATTR_FORMAT] == reflection.TYPE_IMAGE;
			const val = xml.enumGetText(attrNode.ColumnWidth);
			// For Image, it should follow the CustomView options.
			if (val || isImage) {
				return val;
			} else {
				return xml.enumGetText(types.getAttributeDefaultColumnWidth(attrNode.$Name, attrNode[reflection.ATTR_VALUETYPE], attrNode[reflection.ATTR_FORMAT]));
			}
		},

		 /**
		 * @override
		 * Disable filtering
		 */
		getQuerySpec: function(ctx, h, spec) {
			return null;
		}
	});
});